import React, { useState } from "react";
import dayjs from "dayjs";
import { DATE_FORMAT } from "variables/constants";
import PopupButton from "components/button/PopupButton";
import Card from "components/card";
import HeaderComponent from "components/card/HeaderComponent";
import { FaPlus } from "react-icons/fa6";
import { Button, List, Avatar, Space } from "antd";
import LeaveForm from "./LeaveForm";
import HeaderModal from "components/modal/HeaderModal";

const mockLeaveList = [
  { lve_id: 1, lve_date_from: "2025-10-28", lve_date_to: "2025-10-30", lve_type_name: "Vacation", lve_status_name: "Approved", lve_total_days: 3 },
  { lve_id: 2, lve_date_from: "2025-09-15", lve_date_to: "2025-09-15", lve_type_name: "Sick Leave", lve_status_name: "Approved", lve_total_days: 1 },
  { lve_id: 3, lve_date_from: "2025-08-10", lve_date_to: "2025-08-12", lve_type_name: "Personal", lve_status_name: "Approved", lve_total_days: 3 },
  { lve_id: 4, lve_date_from: "2025-11-25", lve_date_to: "2025-11-26", lve_type_name: "Vacation", lve_status_name: "Pending", lve_total_days: 2 },
];
const LeaveTable = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  return (
    <Card>
      <HeaderComponent
        title="Leave History"
        description="View your past and pending leave requests"
        rightNav={
                    <Button
                      onClick={openModal}
                      className="inline-flex items-center justify-center gap-2 rounded-xl text-sm bg-gray-200 text-gray-800 h-9 px-4"
                    >
                      <FaPlus className="h-4 w-4" />
                      <span>Request Leave</span>
                    </Button>
                  }
      >
        <List
          itemLayout="vertical"
          size="large"
          dataSource={mockLeaveList}
          pagination={{
            onChange: (page) => console.log(page),
          }}
          renderItem={(item) => (
            <List.Item key={item.lve_id}>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-sm dark:text-zinc-100">
                    {item.lve_date_from === item.lve_date_to
                      ? dayjs(item.lve_date_from).format(DATE_FORMAT)
                      : `${dayjs(item.lve_date_from).format(DATE_FORMAT)} – ${dayjs(item.lve_date_to).format(DATE_FORMAT)}`}
                  </p>
                  <p className="text-xs text-muted-foreground dark:text-zinc-400">
                    {item.lve_type_name} • {item.lve_total_days} day(s)
                  </p>
                </div>
                <span
                  className={`text-xs status-indicator ${item.lve_status_name.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {item.lve_status_name}
                </span>
              </div>
            </List.Item>
          )}
        />
      </HeaderComponent>
            {isModalOpen && (
              <HeaderModal
                open={isModalOpen}
                onClose={closeModal}
                title="Request Leave"
                description="Submit a new leave request"
                bgcolor="white"
                width={800}
                footer={
                  <div className="p-4 flex justify-end mt-4 gap-2">
                    <Button
                      className="inline-flex items-center justify-center gap-2 rounded-xl text-sm bg-gray-200 text-gray-800 h-9 px-4"
                      onClick={closeModal}
                    >
                      Close
                    </Button>
                    <Button
                      className="inline-flex items-center justify-center gap-2 rounded-xl text-sm btn-gradient-emerald h-9 px-4"
                    >
                      Submit
                    </Button>
                  </div>
                }
              >
                <div className="max-h-[80vh] overflow-y-auto">
                  <LeaveForm />
                </div>
              </HeaderModal>
            )}
    </Card>
  );
};

export default LeaveTable;
